/* eslint-disable import/prefer-default-export */
export const REGION: string = 'eu-west-1';
